import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { patchVehicleInformationAfterInquiryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchVehicleInformationAfterInquiry/patchVehicleInformationAfterInquiryFunction';
import { PatchVehicleInformationAfterInquiryType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchVehicleInformationAfterInquiry/patchVehicleInformationAfterInquiry.type';
import { patchInitialVehicleInformationAfterInquiryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchVehicleInformationAfterInquiry/patchInitialVehicleInformationAfterInquiryFunction';

export const PatchVehicleInformationAfterInquiryOption = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  PatchVehicleInformationAfterInquiryType
> => ({
  mutationKey: ['patch-vehicle-information-after-inquiry'],
  mutationFn: ({
    id,
    damaged_id,
    data,
    type,
  }: PatchVehicleInformationAfterInquiryType) => {
    if (type === 'initial') {
      return patchInitialVehicleInformationAfterInquiryFunction({
        id,
        damaged_id,
        data,
        type,
      });
    } else {
      return patchVehicleInformationAfterInquiryFunction({
        id,
        damaged_id,
        data,
        type,
      });
    }
  },
});
